import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import portalAdminService from '../../services/portalAdminService';
import PortalShell from './PortalShell';

/**
 * /portal/admin/applications — queue with status filter tabs.
 */
export default function PortalAdminApplicationsPage() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const status = params.get('status') || 'pending';
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    portalAdminService.listApplications(status).then((r) => {
      if (r.success) setRows(r.data || []);
      setLoading(false);
    });
  }, [status]);

  const setStatus = (s) => setParams(s === 'pending' ? {} : { status: s });

  const tabs = [
    { key: 'pending', label: 'PENDING' },
    { key: 'accepted', label: 'ACCEPTED' },
    { key: 'declined', label: 'DECLINED' },
    { key: 'not_yet', label: 'NOT YET' },
  ];

  return (
    <PortalShell viewerState="accepted">
      <div style={{ maxWidth: 1000, margin: '32px auto 80px', padding: '0 24px' }}>
        <button onClick={() => navigate('/noir/admin')} className="portal-mono" style={{ background: 'none', border: 'none', color: 'rgba(236,231,218,0.34)', cursor: 'pointer', fontSize: 11, marginBottom: 24 }}>← ADMIN</button>
        <p className="portal-label" style={{ marginBottom: 14 }}>APPLICATIONS</p>
        <h1 className="portal-hero" style={{ marginBottom: 28 }}>The queue.</h1>

        <div style={{ display: 'flex', gap: 8, marginBottom: 28, flexWrap: 'wrap' }}>
          {tabs.map((t) => (
            <button key={t.key} type="button" onClick={() => setStatus(t.key)} className={`portal-chip ${status === t.key ? 'active' : ''}`}>{t.label}</button>
          ))}
        </div>

        <div className="portal-card" style={{ padding: 0 }}>
          {loading ? (
            <p className="portal-mono" style={{ color: 'rgba(236,231,218,0.34)', padding: 20, fontSize: 11 }}>LOADING…</p>
          ) : rows.length === 0 ? (
            <p className="portal-mono" style={{ color: 'rgba(236,231,218,0.34)', padding: 20, fontSize: 11 }}>NOTHING IN THIS BUCKET</p>
          ) : (
            rows.map((row) => (
              <Link key={row.id} to={`/noir/admin/applications/${row.id}`} style={{ display: 'block', padding: '16px 18px', borderBottom: '1px solid rgba(236,231,218,0.12)', textDecoration: 'none' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                  <div className="portal-avatar">
                    {row.avatarUrl ? <img src={row.avatarUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : null}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="portal-serif" style={{ fontSize: 18 }}>{row.displayName}</div>
                    <div className="portal-mono" style={{ fontSize: 10, color: 'rgba(236,231,218,0.34)', marginTop: 4 }}>
                      {row.handle ? `@${row.handle}` : ''}
                      {row.location ? `${row.handle ? ' · ' : ''}${row.location.toUpperCase()}` : ''}
                      {row.submittedAt ? ` · ${formatAgo(row.submittedAt)}` : ''}
                    </div>
                    {row.referrerText && (
                      <p className="portal-serif" style={{ fontStyle: 'italic', fontSize: 14, marginTop: 8, color: 'rgba(236,231,218,0.56)' }}>"{truncate(row.referrerText, 110)}"</p>
                    )}
                  </div>
                  <span className="portal-chip">{row.status.toUpperCase()}</span>
                </div>
              </Link>
            ))
          )}
        </div>
      </div>
    </PortalShell>
  );
}

function truncate(s, n) { return (s || '').length <= n ? (s || '') : (s || '').slice(0, n - 1).trim() + '…'; }
function formatAgo(iso) {
  const ms = Date.now() - new Date(iso).getTime();
  const d = Math.floor(ms / (24 * 3600 * 1000));
  if (d <= 0) return 'TODAY';
  if (d === 1) return '1 DAY AGO';
  if (d < 30) return `${d} DAYS AGO`;
  const mo = Math.floor(d / 30);
  return mo === 1 ? '1 MO AGO' : `${mo} MO AGO`;
}
